import React, { useEffect, useRef, useState } from 'react';
import Reveal from './Reveal';
import { PREVIEW_VIDEO_ID } from './courseContent';
import './courseKit.css';

/**
 * Free class preview. Udemy requires previewable lecture content because it is
 * one of the strongest enrollment levers, and it is the most direct way to
 * raise Hormozi's "perceived likelihood of achievement" term: people can see
 * the teaching before they buy.
 *
 * Click-to-load rather than an eager iframe, so YouTube does not run on every
 * page view and the page stays fast.
 */
const PreviewVideo = ({
  videoId = PREVIEW_VIDEO_ID,
  heading = 'Meet Rob before you enroll',
  blurb = 'A four-minute introduction to Rob, his background, and why he built the AI Trading Bootcamp.',
  videoTitle = 'Rob Grzesik introduces the AI Trading Bootcamp',
  playLabel = "Play Rob's four-minute bootcamp introduction",
  sectionLabel = 'Instructor introduction',
}) => {
  const [playing, setPlaying] = useState(false);
  const iframeRef = useRef(null);

  useEffect(() => {
    if (playing) iframeRef.current?.focus();
  }, [playing]);

  return (
    <section className="ck-preview" aria-label={sectionLabel}>
      <Reveal>
        <h2>{heading}</h2>
      </Reveal>
      <Reveal delay={70}>
        <p className="ck-preview-blurb">{blurb}</p>
      </Reveal>
      <Reveal delay={120}>
        <div className="ck-preview-frame">
          {playing ? (
            <iframe
              ref={iframeRef}
              src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1`}
              title={videoTitle}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              loading="lazy"
              tabIndex="0"
            />
          ) : (
            <button
              type="button"
              className="ck-preview-poster"
              onClick={() => setPlaying(true)}
              aria-label={playLabel}
              data-testid="preview-play"
            >
              <img
                src={`https://i.ytimg.com/vi/${videoId}/maxresdefault.jpg`}
                alt=""
                loading="lazy"
                width="1280"
                height="720"
              />
              <span className="ck-preview-play" aria-hidden="true" />
            </button>
          )}
        </div>
      </Reveal>
    </section>
  );
};

export default PreviewVideo;
